export default __webpack_public_path__ + "static/right-chatgenie-180586e46b3ad859e7c55573ac1ebe4a.svg";